import { assetFolders, currentAssetFolder } from 'common/constants'

export const updateCurrentAssetFolder = (assetFolder: string): void => {
  switch (assetFolder) {
    case assetFolders.Infiniti:
      currentAssetFolder.isInfiniti = true
      currentAssetFolder.isNissan = false
      currentAssetFolder.isIndependent = false
      currentAssetFolder.isUndefined = false
      break
    case assetFolders.Independent:
      currentAssetFolder.isIndependent = true
      currentAssetFolder.isInfiniti = false
      currentAssetFolder.isNissan = false
      currentAssetFolder.isUndefined = false
      break
    case assetFolders.Nissan:
      currentAssetFolder.isNissan = true
      currentAssetFolder.isInfiniti = false
      currentAssetFolder.isIndependent = false
      currentAssetFolder.isUndefined = false
      break
    default:
      currentAssetFolder.isUndefined = true
      currentAssetFolder.isInfiniti = false
      currentAssetFolder.isIndependent = false
      currentAssetFolder.isNissan = false
      break
  }
}
